import { timeline } from "@/pages/home/content";

const tagClass: Record<string, string> = {
  首发: "bg-primary-100 text-primary-900",
  跟进: "bg-secondary-200/70 text-secondary-900",
  回应: "bg-accent-100 text-accent-900",
  反转: "bg-accent-200/70 text-accent-950",
  实锤: "bg-primary-500 text-background-50",
};

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-700">
              ONGOING TRACKING
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              今日瓜线
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              追踪一条线索在全天内的演化：首发 → 跟进 → 回应 → 反转 → 落定。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-800 whitespace-nowrap">
            <i className="ri-pulse-line" />
            实时追踪 08-28
          </span>
        </div>

        <div className="relative mt-8 border-l-2 border-background-300 pl-6 md:pl-8">
          {timeline.map((ev, idx) => (
            <div key={idx} className="relative pb-8 last:pb-0">
              <span className="absolute -left-[33px] top-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-primary-500 bg-background-50 md:-left-[41px]">
                <span className="h-2 w-2 rounded-full bg-primary-500" />
              </span>
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-label text-lg font-bold text-foreground-950">
                  {ev.time}
                </span>
                <span className="text-xs text-foreground-600">{ev.category}</span>
                <span
                  className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${tagClass[ev.tag]}`}
                >
                  {ev.tag}
                </span>
              </div>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-800">
                {ev.text}
              </p>
              <span className="mt-2 inline-flex items-center gap-1 text-xs text-primary-700 whitespace-nowrap">
                <i className="ri-fire-line" />
                讨论热度 {ev.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}